module.exports = __webpack_public_path__ + "static/media/Ghost.7647b66c.png";